import './style.scss';
import { useState, useRef, useEffect } from 'react';
import pinMain from 'assets/common/ico_pin03.png';
import SidebarScroll, { Element } from '../../SidebarScroll';
import { GetStyledCompImg } from 'common-modules/general/Modules/functions';
import MainModel from 'common-modules/general/Common/Logic/Main/MainSalesCommon';
import { observer } from 'mobx-react';
import { toJS } from 'mobx';
import Accordion from 'common-modules/general/Common/Components/Accordion/DesktopAccordion';
import { userInfo } from 'os';

interface Props {
  mainModel: MainModel;
}

const Info = observer(({ mainModel }: Props) => {
  const calendarRef = useRef<any>(null);
  const subscriptionRef = useRef<any>(null);
  const contractRef = useRef<any>(null);
  const detailsRef = useRef<any>(null);
  const winningRef = useRef<any>(null);
  const siteRef = useRef<any>(null);
  const showroomRef = useRef<any>(null);
  const faqsRef = useRef<any>(null);

  useEffect(() => {
    mainModel.getFAQList({ page: 1 });
  }, [mainModel]);

  const faqList = toJS(mainModel.faqData.data?.list);
  const complexInfo = toJS(mainModel.mainData.data);

  useEffect(() => {
    // #1. (분양지 위치) 네이버맵을 위한 좌표 변환
    if (naver && naver.maps && mainModel) {
      const address_1: string = complexInfo?.addrBizLnd || '';

      if (address_1 !== '') {
        naver.maps.Service.geocode({ query: address_1 }, (status, response) => {
          // 성공 시의 response 처리
          if (status === naver.maps.Service.Status.OK) {
            if (response.v2.addresses.length <= 0) {
              return;
            }
            const item: naver.maps.Service.AddressItemV2 = response.v2.addresses[0];

            // 네이버맵 가동 (현장위치)
            const location_1_map: naver.maps.Map = new naver.maps.Map('location_1', {
              center: new naver.maps.LatLng(Number(item.y), Number(item.x)),
              zoom: 18, // 지도의 초기 줌 레벨
              minZoom: 15, // 지도의 최소 줌 레벨
              maxZoom: 20, // 지도의 최대 줌 레벨
              zoomControl: true, // 줌 컨트롤의 표시 여부
              mapTypeControl: true
            });
            // 네이버맵 마커 표시 (현장위치)
            new naver.maps.Marker({
              position: new naver.maps.LatLng(Number(item.y), Number(item.x)),
              map: location_1_map,
              icon: pinMain
            });
          }
        });
      }

      // #1. (주택전시관 위치) 네이버맵을 위한 좌표 변환
      const address_2: string = complexInfo?.addrBizExhibLnd || '';

      if (address_2 != '') {
        naver.maps.Service.geocode({ query: address_2 }, (status, response) => {
          // 성공 시의 response 처리
          if (status === naver.maps.Service.Status.OK) {
            if (response.v2.addresses.length <= 0) {
              return;
            }
            const item: naver.maps.Service.AddressItemV2 = response.v2.addresses[0];

            // 네이버맵 가동 (현장위치)
            const location_2_map: naver.maps.Map = new naver.maps.Map('location_2', {
              center: new naver.maps.LatLng(Number(item.y), Number(item.x)),
              zoom: 17,
              minZoom: 15, // 지도의 최소 줌 레벨
              maxZoom: 20, // 지도의 최대 줌 레벨
              zoomControl: true, // 줌 컨트롤의 표시 여부
              mapTypeControl: true
            });
            // 네이버맵 마커 표시 (현장위치)
            new naver.maps.Marker({
              position: new naver.maps.LatLng(Number(item.y), Number(item.x)),
              map: location_2_map,
              icon: pinMain
            });
          }
        });
      }
    }
  }, [mainModel, complexInfo]);

  // handle accordion
  const [activePostNumber, setActivePostNumber] = useState('');

  /**
   * @value
   * @description * 사이드 바 리스트 목록
   */
  const sidebarList = [
    { name: '분양 일정', isActive: true },
    { name: '현장 위치', isActive: true },
    { name: '주택전시관 위치', isActive: true },
    { name: '공급내역', isActive: true },
    { name: '청약 안내', isActive: true },
    { name: '당첨 안내', isActive: true },
    { name: '계약 안내', isActive: false },
    { name: '자주 묻는 질문', isActive: true }
  ];

  return (
    <div className="contents-info">
      <div className="content">
        <SidebarScroll sidebarList={sidebarList} />

        {/* 분양일정 */}
        {sidebarList[0].isActive ? (
        <Element name={sidebarList[0].name}>
          <div className="section-calendar" ref={calendarRef} id="calendar">
            <h3>분양 일정</h3>
            <div className="calendar">
              <div className="month">
                <div className="schedule">
                <table>
                    <thead>
                      <tr>
                        <th>일</th>
                        <th>월</th>
                        <th>화</th>
                        <th>수</th>
                        <th>목</th>
                        <th>금</th>
                        <th>토</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr>
                        <td>
                          <span className="day">2023/3/26</span>
                        </td>
                        <td>
                          <span className="day">3/27</span>
                        </td>
                        <td>
                          <span className="day">3/28</span>
                        </td>
                        <td>
                          <span className="day">3/29</span>
                        </td>
                        <td>
                          <span className="day">3/30</span>
                        </td>
                        <td>
                          <span className="day on">3/31</span>
                        </td>
                        <td>
                          <span className="day">4/1</span>
                        </td>
                      </tr>
                      <tr className="border-bt">
                        <td></td>
                        <td></td>
                        <td></td>
                        <td></td>
                        <td></td>
                        <td>
                          <div className="schedule-area">
                            <span className="schedule-item orange">GRAND OPEN</span>
                          </div>
                        </td>
                        <td></td>
                      </tr>
                      <tr>
                        <td>
                          <span className="day">4/2</span>
                        </td>
                        <td>
                          <span className="day">4/3</span>
                        </td>
                        <td>
                          <span className="day">4/4</span>
                        </td>
                        <td>
                          <span className="day">4/5</span>
                        </td>
                        <td>
                          <span className="day">4/6</span>
                        </td>
                        <td>
                          <span className="day">4/7</span>
                        </td>
                        <td>
                          <span className="day">4/8</span>
                        </td>
                      </tr>
                      <tr className="border-bt">
                        <td><div className="schedule-area"></div></td>
                        <td><div className="schedule-area"></div></td>
                        <td><div className="schedule-area"></div></td>
                        <td><div className="schedule-area"></div></td>
                        <td><div className="schedule-area"></div></td>
                        <td><div className="schedule-area"></div></td>
                        <td><div className="schedule-area"></div></td>
                      </tr>
                      <tr>
                        <td>
                          <span className="day">4/9</span>
                        </td>
                        <td>
                          <span className="day on">4/10</span>
                        </td>
                        <td>
                          <span className="day on">4/11</span>
                        </td>
                        <td>
                          <span className="day on">4/12</span>
                        </td>
                        <td>
                          <span className="day">4/13</span>
                        </td>
                        <td>
                          <span className="day">4/14</span>
                        </td>
                        <td>
                          <span className="day">4/15</span>
                        </td>
                      </tr>
                      <tr className="border-bt">
                        <td>
                          <div className="schedule-area"></div>
                        </td>
                        <td>
                          <div className="schedule-area">
                            <span className="schedule-item blue">특별공급</span>
                          </div>
                        </td>
                        <td>
                          <div className="schedule-area">
                            <span className="schedule-item blue">1순위</span>
                          </div>
                        </td>
                        <td>
                          <div className="schedule-area">
                            <span className="schedule-item blue">2순위</span>
                          </div>
                        </td>
                        <td>
                          <div className="schedule-area"></div>
                        </td>
                        <td>
                          <div className="schedule-area"></div>
                        </td>
                        <td>
                          <div className="schedule-area"></div>
                        </td>
                      </tr>
                      <tr>
                        <td>
                          <span className="day">4/16</span>
                        </td>
                        <td>
                          <span className="day">4/17</span>
                        </td>
                        <td>
                          <span className="day on">4/18</span>
                        </td>
                        <td>
                          <span className="day">4/19</span>
                        </td>
                        <td>
                          <span className="day">4/20</span>
                        </td>
                        <td>
                          <span className="day on">4/21</span>
                        </td>
                        <td>
                          <span className="day on">4/22</span>
                        </td>
                      </tr>
                      <tr className="border-bt">
                        <td><div className="schedule-area"></div></td>
                        <td><div className="schedule-area"></div></td>
                        <td>
                          <div className="schedule-area">
                            <span className="schedule-item orange">당첨자 발표</span>
                          </div>
                        </td>
                        <td><div className="schedule-area"></div></td>
                        <td><div className="schedule-area"></div></td>
                        <td colSpan={2}>
                          <div className="schedule-area">
                            <span className="schedule-item border-right green">당첨자 서류제출 및 검수기간</span>
                          </div>
                        </td>
                      </tr>
                      <tr>
                        <td>
                          <span className="day on">4/23</span>
                        </td>
                        <td>
                          <span className="day on">4/24</span>
                        </td>
                        <td>
                          <span className="day on">4/25</span>
                        </td>
                        <td>
                          <span className="day">4/26</span>
                        </td>
                        <td>
                          <span className="day">4/27</span>
                        </td>
                        <td>
                          <span className="day">4/28</span>
                        </td>
                        <td>
                          <span className="day">4/29</span>
                        </td>
                      </tr>
                      <tr className="border-bt">
                      <td colSpan={3}>
                          <div className="schedule-area">
                            <span className="schedule-item border-left green">당첨자 서류제출 및 검수기간</span>
                          </div>
                        </td>
                        <td><div className="schedule-area"></div></td>
                        <td><div className="schedule-area"></div></td>
                        <td><div className="schedule-area"></div></td>
                        <td><div className="schedule-area"></div></td>
                      </tr>
                      <tr>
                        <td>
                          <span className="day">4/30</span>
                        </td>
                        <td>
                          <span className="day">5/1</span>
                        </td>
                        <td>
                          <span className="day on">5/2</span>
                        </td>
                        <td>
                          <span className="day on">5/3</span>
                        </td>
                        <td>
                          <span className="day on">5/4</span>
                        </td>
                        <td>
                          <span className="day">5/5</span>
                        </td>
                        <td>
                          <span className="day">5/6</span>
                        </td>
                      </tr>
                      <tr className="border-bt">
                        <td><div className="schedule-area"></div></td>
                        <td><div className="schedule-area"></div></td>
                        <td>
                          <div className="schedule-area">
                            <span className="schedule-item pink">정당계약 1일차</span>
                          </div>
                        </td>
                        <td>
                          <div className="schedule-area">
                            <span className="schedule-item pink">정당계약 2일차</span>
                          </div>
                        </td>
                        <td>
                          <div className="schedule-area">
                            <span className="schedule-item pink">정당계약 3일차</span>
                          </div>
                        </td>
                        <td><div className="schedule-area"></div></td>
                        <td><div className="schedule-area"></div></td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          </div>
        </Element>
        ) : null}

        {/* 현장 위치 */}
        {sidebarList[1].isActive ? (
        <Element name={sidebarList[1].name}>
          <div className="section-map" ref={siteRef} id="site">
            <h3>현장 위치</h3>
            <div className="content-map-area">
              {/* <h4 className="txt-desc-medium03 mb-30">{complexInfo?.addrBizLnd || ''}</h4> */}
              <h4 className="txt-desc-medium03 mb-30">광주광역시 남구 봉선동 1143-36</h4>
              <div className="info">
                <span className="bold">전화번호</span>
                <span className="normal">{complexInfo?.cntsBiz || ''}</span>
              </div>

              <div className="img-box">
                {/* 지도 START  */}
                <div id="location_1" style={{ width: '100%', height: '100%' }}></div>
              </div>
            </div>
          </div>
        </Element>
        ) : null}

        {/* 주택전시관 위치  */}
        {sidebarList[2].isActive ? (
        <Element name={sidebarList[2].name}>
          <div className="section-map" ref={showroomRef} id="showroom">
            <h3>주택전시관 위치</h3>
            <div className="content-map-area">
              {/* <h4 className="txt-desc-medium03 mb-30">{complexInfo?.addrBizExhibLnd || ''}</h4> */}
              <h4 className="txt-desc-medium03 mb-30">광주광역시 광산구 신촌동 682-12</h4>
              <div className='info-wrap'>
                <div className="info">
                  <span className="bold">운영시간</span>
                  <span className="normal">평일(주말) 오전 10시 ~ 오후 6시</span>
                </div>
                <div className="info">
                  <span className="bold">전화번호</span>
                  <span className="normal">{complexInfo?.cntsBiz || ''}</span>
                </div>
              </div>

              <div className="img-box">
                {/* 지도 START  */}
                <div id="location_2" style={{ width: '100%', height: '100%' }}></div>
              </div>
            </div>
          </div>
        </Element>
        ) : null}

        {/* 공급내역 */}
        {sidebarList[3].isActive ? (
        <Element name={sidebarList[3].name}>
          <div className="section-subscription" ref={detailsRef} id="details">
            <h3>공급 내역</h3>
            <h4>평면별 공급 내역</h4>
            <div className="table-container">
              <table>
                <colgroup>
                  <col style={{ width: '25%' }} />
                  <col style={{ width: '25%' }} />
                  <col style={{ width: '25%' }} />
                  <col style={{ width: '25%' }} />
                </colgroup>
                <thead>
                  <tr>
                    <th>평면타입</th>
                    <th className="line-b">세대수</th>
                    <th className="line-b">일반분양</th>
                    <th className="line-b">분양가(천원)</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <th className="border">63A</th>
                    <td className="border">123</td>
                    <td className="border">98</td>
                    <td>최저가 : 498,000 / 최고가 : 541,000</td>
                  </tr>
                  <tr>
                    <th className="border">63B</th>
                    <td className="border">14</td>
                    <td className="border">14</td>
                    <td>최저가 : 495,000 / 최고가 : 532,000</td>
                  </tr>
                  <tr>
                    <th className="border">84A</th>
                    <td className="border">278</td>
                    <td className="border">38</td>
                    <td>최저가 : 666,000 / 최고가 : 724,000</td>
                  </tr>
                  <tr>
                    <th className="border">84B</th>
                    <td className="border">127</td>
                    <td className="border">26</td>
                    <td>최저가 : 648,000 / 최고가 : 697,000</td>
                  </tr>
                </tbody>
              </table>
            </div>

            {/* <h4 className="mt-50">청약신청 가능한 청약예금의 예치금액(만원)</h4>
            <div className="table-container">
              <table>
                <colgroup>
                  <col style={{ width: '25%' }} />
                  <col style={{ width: '25%' }} />
                  <col style={{ width: '25%' }} />
                  <col style={{ width: '25%' }} />
                </colgroup>
                <thead>
                  <tr>
                    <th>구분</th>
                    <th className="line-b">구미시 및 경상북도</th>
                    <th className="line-b">그 밖의 광역시 (대구광역시)</th>
                    <th className="line-b">특별시 및 부산광역시</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <th>전용면적 85㎡이하</th>
                    <td className="border">200</td>
                    <td className="border">250</td>
                    <td>300</td>
                  </tr>
                  <tr>
                    <th>전용면적 102㎡이하</th>
                    <td className="border">300</td>
                    <td className="border">400</td>
                    <td>600</td>
                  </tr>
                  <tr>
                    <th>전용면적 135㎡이하</th>
                    <td className="border">400</td>
                    <td className="border">700</td>
                    <td>1,000</td>
                  </tr>
                  <tr>
                    <th className="border-bt">모든면적</th>
                    <td className="border border-bt">500</td>
                    <td className="border border-bt">1,000</td>
                    <td className="border-bt">1,500</td>
                  </tr>
                </tbody>
              </table>
            </div> */}

            {/* <div className="caution-text">
            * 상기 금액에 대한 자세한 사항은 상세보기(입주자모집공고)를 참고하시기 바랍니다.
            </div>

            <h3 className="mt-70">계약조건 안내</h3>
            <div className="progress-bar-type">
              <div className="bar01">
                <div className="txt">계약금: 10%</div>
              </div>
              <div className="bar02">
                <div className="txt">중도금: 60%(무이자)</div>
              </div>
              <div className="bar03">
                <div className="txt">잔금: 30%</div>
              </div>
            </div> */}
          </div>
        </Element>
        ) : null}

        {/* 청약 안내*/}
        {sidebarList[4].isActive ? (
        <Element name={sidebarList[4].name}>
          <div className="section-subscription" ref={subscriptionRef} id="subscription">
            <h3>청약 안내</h3>
            <h4>청약 일정 안내</h4>
            <div className="table-container type-document type01">
              <table className="table-col">
                <colgroup>
                  <col style={{ width: '10%' }} />
                  <col style={{ width: '19%' }} />
                  <col style={{ width: '11%' }} />
                  <col style={{ width: '11%' }} />
                  <col style={{ width: '11%' }} />
                  <col style={{ width: '19%' }} />
                  <col style={{ width: '19%' }} />
                </colgroup>

                <thead>
                  <tr>
                    <th className="line-b">구분</th>
                    <th className="line-b">특별공급<br />(기관추천, 다자녀, 신혼부부, 노부모부양,생애최초)</th>
                    <th className="line-b">일반공급 1순위</th>
                    <th className="line-b">일반공급 2순위</th>
                    <th className="line-b">당첨자발표</th>
                    <th className="line-b">자격검증 서류제출<br />(당첨자 적격여부 확인)</th>
                    <th className="line-b">계약체결</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td className="border">일정</td>
                    <td className="border">2023.04.10.(월)</td>
                    <td className="border">2023.04.11.(화)</td>
                    <td className="border">2023.04.12.(수)</td>
                    <td className="border">2023.04.18.(화)</td>
                    <td className="border">2023.04.21.(금) ~ 04.25(화) </td>
                    <td>2023.05.02.(화) ~ 05.04.(목)</td>
                  </tr>
                  <tr>
                    <td className="border">방법</td>
                    <td colSpan={3} className="border">인터넷 청약(09:00 ~ 17:30)</td>
                    <td className="border">개별조회<br />(청약Home 로그인 후 조회 가능)</td>
                    <td colSpan={2} className="text-left">• e편한세상 봉선 셀레스티지 주택전시관 방문 접수<br />- 사전방문예약제 (구비서류 등 지참 방문)</td>
                  </tr>
                  <tr>
                    <td className="border">장소</td>
                    <td className="border text-left">
                    • 사업주체 주택전시관(10:00~14:00)<br />
                    • 한국부동산원 '청약Home'<br />
                        - PC : <a href='https://www.applyhome.co.kr'>www.applyhome.co.kr</a><br />
                        - 스마트폰앱 <br />
                        * 청약통장 가입은행 구분 없음
                    </td>
                    <td colSpan={3} className="border text-left">
                    • 한국부동산원 청약Home 홈페이지<br />
                        - PC : <a href='https://www.applyhome.co.kr'>www.applyhome.co.kr</a><br />
                        - 스마트폰앱
                    </td>
                    <td colSpan={2} className="text-left">
                    • e편한세상 봉선 셀레스티지 주택전시관<br />- 광주광역시 광산구 신촌동 682-12
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
            <h4>청약안내</h4>
            <div className="table-container type01">
              <table>
                <colgroup>
                  <col style={{ width: '8%' }} />
                  <col style={{ width: '15%' }} />
                  <col style={{ width: '20%' }} />
                  <col style={{ width: '10%' }} />
                  <col style={{ width: '22%' }} />
                </colgroup>

                <thead>
                  <tr>
                    <th className="line-b">구분</th>
                    <th className="line-b">신청대상자</th>
                    <th className="line-b">신청일시</th>
                    <th className="line-b">신청방법</th>
                    <th className="line-b">신청장소</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <th className="border">특별공급</th>
                    <td className="border">기관추천, 다자녀가구,신혼부부, 노부모부양, 생애최초</td>
                    <td className="border">
                      2023.04.10(월) <br />
                      (청약Home 인터넷 : 09:00~17:30) <br />
                      (사업주체 주택전시관 : 10:00~14:00)
                    </td>
                    <td className="border border-bt" rowSpan={3}>인터넷 청약<br />(PC 또는 스마트폰)</td>
                    <td className='text-left'>
                      • 한국부동산원 '청약Home' 홈페이지 <br />
                      {/* <a href='https://www.applyhome.co.kr' title='청약Home 홈페이지 바로가기'>(www.applyhome.co.kr)</a> <br /> */}
                      - PC : <a href='https://www.applyhome.co.kr' title='청약Home 홈페이지 바로가기'>www.applyhome.co.kr</a> <br />
                      - ‘청약홈’앱 <br /><br />
                      • 사업주체 주택전시관<br />
                      (고령자, 장애인 등 정보취약계층에 한함)
                    </td>
                  </tr>
                  <tr>
                    <th className="border border-bt" rowSpan={2}>일반공급</th>
                    <td className="border">1순위</td>
                    <td className="border">2023.04.11(화) 09:00~17:30</td>
                    <td className='text-left border-bt' rowSpan={2}>
                      • 한국부동산원 '청약Home' 홈페이지 <br />
                      {/* <a href='https://www.applyhome.co.kr' title='청약Home 홈페이지 바로가기'>(www.applyhome.co.kr)</a> <br /> */}
                      - PC : <a href='https://www.applyhome.co.kr' title='청약Home 홈페이지 바로가기'>www.applyhome.co.kr</a> <br />
                      - ‘청약홈’앱 <br /><br />
                      • 청약통장 가입은행<br />(고령자, 장애인 등 정보취약계층에 한함)
                    </td>
                  </tr>
                  <tr>
                    <td className="border border-bt">2순위</td>
                    <td className="border border-bt">2023.04.12(수) 09:00~17:30</td>
                  </tr>
                </tbody>
              </table>
            </div>
            <div className="caution-text">
              <p>
                * 스마트폰앱 : 구글플레이스토어, 애플앱스토어에서 “청약홈” 검색<br />
                - 스마트폰앱을 이용하여 청약할 경우에는 청약일 상당 기간 전에 앱을 설치하고 청약 시 사용할 공동인증서를 청약홈 앱으로 미리 저장하시거나, 금융인증서, 네이버인증서 또는 KB모바일인증서를 미리 발급받으시기 바랍니다. 청약 당일 인증서 설치 문제로 청약이 곤란할 경우에는 PC를 이용하여 주시기 바랍니다.
              </p>
              <p>
                * 2018.05.04. 개정된 「주택공급에 관한 규칙」에 의거 특별공급 신청 방법이 ‘주택전시관 방문 신청’에서 ‘인터넷(청약Home 홈페이지 <a href='https://www.applyhome.co.kr' title='청약Home 홈페이지 바로가기'>www.applyhome.co.kr</a>) 청약 신청’으로 변경되었으며, 특별공급의 경우 인터넷 청약이 원칙이며 정보취약계층(고령자 및 장애인 등) 등에 한하여 주택전시관 방문접수(은행창구 접수 불가) 허용됩니다. (방문 접수시간 : 10:00∼14:00)
              </p>

              <p>
                * 일반공급의 경우 인터넷 청약이 원칙이나 정보취약계층(고령자 및 장애인 등) 등에 한하여 청약통장 가입은행 본·지점에서 청약이 가능합니다. (창구 접수시간 : 09:00∼16:00)
              </p>
              <p>
                * 청약통장 가입은행에서 청약 접수 시 각 은행 본·지점의 운영시간이 상이할 수 있으니 확인 후 방문하시기 바랍니다. 
              </p>
              <p>
                * 청약 신청한 주택의 신청취소는 신청 당일 청약신청 마감 이전까지 가능하며, 청약 접수 종료 이후에는 어떠한 경우라도 신청 취소 및 변경이 불가하오니 유의하여 주시기 바랍니다.
              </p>
              <p>
                * 특별공급 및 일반공급 청약 시 가점 항목 등 청약자격을 확인(검증)하지 않고 신청자 기재 사항만으로 청약신청을 받으며 당첨자에 한하여 계약체결 시 주민등록표등·초본, 가족관계증명서 등 관련 서류를 제출받아 주택공급 신청내용과 청약자격을 대조한 후 청약신청 내용과 청약자격이 일치할 경우에 계약체결이 가능하므로 청약신청 시 유의하시기 바랍니다.
              </p>
            </div>

            {/* <h4 className="mt-50">인터넷 청약코드</h4>
            <div className="table-container">
              <table>
                <colgroup>
                  <col style={{ width: '33%' }} />
                  <col style={{ width: '33%' }} />
                  <col style={{ width: 'auto' }} />
                </colgroup>
                <thead>
                  <tr>
                    <th className="line-b">주택형주거전용 면적기준(㎡)</th>
                    <th className="line-b">공급 세대 수</th>
                    <th className="line-b">주택관리번호 및 아파트코드(모델번호)</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td className="border">68.9969A</td>
                    <td className="border">118</td>
                    <td>2022000424-01</td>
                  </tr>
                  <tr>
                    <td className="border">68.9120B</td>
                    <td className="border">22</td>
                    <td>2022000424-02</td>
                  </tr>
                  <tr>
                    <td className="border">84.9458A</td>
                    <td className="border">192</td>
                    <td>2022000424-03</td>
                  </tr>
                  <tr>
                    <td className="border">84.9616B</td>
                    <td className="border">201</td>
                    <td>2022000424-04</td>
                  </tr>
                  <tr>
                    <td className="border border-bt">114.8237</td>
                    <td className="border border-bt">74</td>
                    <td className='border-bt'>2022000424-05</td>
                  </tr>
                </tbody>
              </table>
            </div>
            <div className="caution-text">
              <p>
                * 본 아파트는 건전한 주택청약 문화정착을 위한 정부의 방침에 따라 인터넷 청약을 원칙으로 하고 있으므로 청약 이전에 ①청약통장 가입은행 및 취급은행을 방문하여 인터넷뱅킹 가입 및 공동인증서를 신청접수일 이전에 미리 발급받거나, ②금융인증서, ③네이버인증서 또는 ④KB모바일인증서를 미리 발급받으시기 바랍니다.
              </p>
              <p>
                * 한국부동산원에서 운영하는 '청약Home' 홈페이지(<a href='https://www.applyhome.co.kr'  target='_blank'>www.applyhome.co.kr</a>)에서 청약 신청자의 편의를 위하여 인터넷 청약서비스를 시행하고 있으며, 아래와 같이 인증서 로그인이 가능하오니 서비스 이용시 참고하시기 바랍니다.
              </p>
            </div> */}
          </div>
        </Element>
        ) : null}

        {/* 당첨 안내 */}
        {sidebarList[5].isActive ? (
        <Element name={sidebarList[5].name}>
          <div className="section-subscription" ref={winningRef} id="winning">
          <h3>당첨 안내</h3>
            <div className="table-container type01">
              <table className="table-col">
                <colgroup>
                  <col style={{ width: '10%' }} />
                  <col style={{ width: '15%' }} />
                  <col style={{ width: '23%' }} />
                </colgroup>

                <thead>
                  <tr>
                    <th className="line-b">구분</th>
                    <th className="line-b">신청 대상자</th>
                    <th className="line-b">당첨자 발표 및 동호수/예비입주자<br/>및 예비순번 발표</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <th className="border">특별 공급</th>
                    <td className="border">기관추천, 다자녀가구, 신혼부부, 노부모부양, 생애최초</td>
                    <td rowSpan={3} className="border-bt">
                      <ul>
                        <li>일시: 2023.04.18(화)</li>
                        <li>
                          확인방법 : <br />
                          - 한국부동산원 청약Home
                          (<a href='https://www.applyhome.co.kr' title='청약Home 홈페이지 바로가기'  target='_blank'>www.applyhome.co.kr</a>)
                           또는 ‘청약홈’앱에서 개별조회
                          <br />
                          * 공동인증서, 금융인증서, 네이버인증서 또는 KB모바일인증서로 로그인 후 조회 가능
                        </li>
                      </ul>
                    </td>
                  </tr>
                  <tr>
                    <th rowSpan={2} className="border border-bt">일반 공급</th>
                    <td className="border">1순위</td>
                  </tr>
                  <tr>
                    <td className="border border-bt">2순위</td>
                  </tr>
                </tbody>
              </table>
            </div>
            <div className="caution-text">
              <p>
                * 당첨자 명단은 '청약Home' 홈페이지(<a href='https://www.applyhome.co.kr'  target='_blank'>www.applyhome.co.kr</a>)에서 본인이 직접 확인하셔야 하며 당첨자 및 동·호수 확인 시에는 인증서 로그인 후 조회 가능함을 알려드리오니 착오 없으시기 바랍니다. 다만, 고령자 및 장애인 등 정보취약계층으로서 인터넷 청약이 불가하여 주택전시관(특별공급) 또는 은행창구(일반공급) 등에 방문하여 청약신청한 경우에 한하여 정보입력(주택명, 주택형, 성명, 생년월일 입력) 조회가 가능하나 정보 오입력 등의 경우 부정확한 내역이 조회될 수 있으므로 인증서를 발급받으신 분은 반드시 인증서로 로그인하여 정확한 당첨내역을 확인하시기 바랍니다. <br />- 인터넷 청약신청 건에 대해서는 ‘정보입력’에 의한 당첨내역 조회가 불가(당첨 여부에 관계없이 ‘당첨내역이 없음’으로 표기됨)하오니 반드시 인증서로 로그인하시어 당첨내역을 확인하시기 바랍니다.
              </p>
              <p>
                * 당첨자 및 동·호수, 예비입주자 및 예비순번 발표 시 개별서면 통지는 하지 않습니다. (전화문의는 착오 가능성 때문에 응답하지 않으니 이 점 양지하시기 바랍니다.)
              </p>
              <p>
                * 당첨자의 계약기간은 주택소유실태 및 과거 당첨 사실 유무 전산검색 소요기간에 따라 변경될 수 있으며, 당첨자에 대한 주택소유실태 전산검색결과 공급자격 또는 선정순위 등 적격자(정당 당첨자)에 한하여 계약을 체결하고 부적격자는 부적격자가 아님을 증명할 수 있는 서류를 제출하여 적격자로 재확인 후 계약을 체결합니다.
              </p>
              <p>
                * 당첨자 명단은 상기 장소에서 본인이 직접 확인하여야 하며 개별서면 통지는 하지 않습니다. (전화문의는 착오 가능성 때문에 응답하지 않으니 이점 양지하시기 바랍니다.)
              </p>
            </div>

            <h4 className="mt-50">인터넷, 휴대폰 문자 당첨자발표 서비스 이용 안내</h4>
            <div className="table-container type01">
              <table className="table-col">
                <colgroup>
                  <col style={{ width: '10%' }} />
                  <col style={{ width: '10%' }} />
                  <col style={{ width: 'auto' }} />
                </colgroup>

                <thead>
                  <tr>
                    <th className="line-b" colSpan={2}>구분</th>
                    <th className="line-b" colSpan={2}>한국부동산원 청약Home (全 은행 청약자)</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td className="border" colSpan={2}>이용기간</td>
                    <td colSpan={2}>2023.04.18.(화) ~ 2023.04.24.(월) (7일간)</td>
                  </tr>
                  <tr>
                    <td className="border" colSpan={2}>
                      인터넷
                    </td>
                    <td  colSpan={2}>
                      <ul>
                        <li>
                          한국부동산원 '청약Home' 홈페이지(<a href='https://www.applyhome.co.kr'  target='_blank'>www.applyhome.co.kr</a>) 접속 → 청약조회 → 당첨조회(최근10일)
                        </li>
                        <li>
                          스마트폰앱 접속 → 청약당첨조회 → 당첨조회(최근10일)
                          <br/>
                          ※ 당첨조회(10일) 기간이 경과한 뒤에도 마이페이지 	&#62; 청약제한사항확인 또는 청약소통방 &#62; 당첨사실 조회하기(아파트)를 통해 당첨내역 확인 가능
                        </li>
                      </ul>
                    </td>
                  </tr>
                  <tr>
                    <td rowSpan={2} className="border border-bt">
                      휴대폰<br />문자서비스
                    </td>
                    <td className="border">대상</td>
                    <td colSpan={2}>특별공급 및 일반공급 청약 신청 시 휴대폰번호를 등록하신 분 중 당첨(예비)자 </td>
                  </tr>
                  <tr>
                    <td className="border border-bt">제공일시</td>
                    <td colSpan={2} className='border-bt'>2023.04.18.(화) 08:00 (제공시간은 사정에 따라 변동될 수 있음)</td>
                  </tr>
                </tbody>
              </table>
            </div>
            <div className="caution-text">
              <p>
                * 휴대폰 문자서비스는 청약신청자의 편의도모를 위한 부가서비스로서 정확한 당첨 여부는 상기 발표일에 청약홈 &#62; 청약당첨조회 당첨자 발표장소 등에서 본인이 반드시 재확인하셔야 합니다
              </p>
            </div>
            {/* <div className="btn-wrap">
              <button
                onClick={e => {
                  window.open('https://www.applyhome.co.kr');
                }}>
                당첨자 및 예비당첨자 확인 (‘청약Home’ 홈페이지)
              </button>
            </div> */}
             <h4>당첨자(정당 당첨자 및 예비 당첨자) 자격검증 서류제출 안내</h4>
            <div className="table-container type01">
              <table className="table-col">
                <colgroup>
                  <col style={{ width: '12.5%' }} />
                  <col style={{ width: '12.5%' }} />
                  <col style={{ width: '25%' }} />
                  <col style={{ width: '25%' }} />
                  <col style={{ width: '25%' }} />
                </colgroup>

                <thead>
                  <tr>
                    <th colSpan={2} className="line-b">구분</th>
                    <th className="line-b">당첨자 자격검증 서류제출 일정</th>
                    <th className="line-b">서류 제출장소</th>
                    <th className="line-b">비고</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <th rowSpan={2} className="border border-bt">정당 및 예비 당첨자</th>
                    <th className="border">특별공급</th>
                    <td rowSpan={2} className="border border-bt">2023.04.21.(금) ~ 2023.04.25.(화) (10:00 ~ 17:00)</td>
                    <td rowSpan={2} className="border border-bt text-left">• e편한세상 봉선 셀레스티지 주택전시관<br />
                        - 광주광역시 광산구 신촌동 682-12<br />
                        - 구비서류 등 지참 방문
                    </td>
                    <td rowSpan={2} className="text-left border-bt">• 사전방문예약제<br />
                        - 분양 홈페이지<br />
                        - <a href='https://www.dlcon-apt.co.kr'  target='_blank'>www.dlcon-apt.co.kr</a></td>
                  </tr>
                  <tr>
                    <th className="border border-bt">일반공급</th>
                  </tr>
                </tbody>
              </table>
            </div>
            <div className="caution-text">
              <p>
                * 특별공급 예비 당첨자 및 일반공급 예비 당첨자의 자격확인서류 제출 기한은 추후 당사 홈페이지 및 개별안내 해드릴 예정입니다.
              </p>
              <p>
              * 입주대상자 자격확인 서류제출 기간 이내 방문이 어려운 당첨자 및 예비입주자의 경우 견본주택으로 통지 후 계약체결 전 자격확인 서류 일체 구비사항을 준비하시어 계약체결을 하시기 바랍니다. 
              </p>
              <p>
                * 서류 제출은 견본주택 방문접수를 원칙으로 하나, 코로나 바이러스 감염증(코로나19) 확산 방지 및 정부 정책에 따라 제출 기간 및 제출 방법이 변경될 수 있습니다.
              </p>
              <p>
                * 당첨자(특별공급, 일반공급) 및 예비입주자는 지정된 당첨자 서류제출 기간 내에 당첨자에 대한 주택소유실태 전산검색결과 공급 자격 또는 선정순위, 신청내역 등 적격 자격에 대한 서류를 제출하여야 하고 부적격 통보를 받거나 부적격 의심 사유가 있어 소명이 필요한 경우 사업주체가 요구하는 소명기간 내(계약 체결 이전)제출하여야 합니다.(자격확인 서류를 제출하지 아니할 경우에는 계약체결일 계약 진행 불가함)
              </p>
              <p>
                * 접수된 서류는 일체 반환하지 않으며, 계약을 체결하지 않은 자의 서류는 분양주체에서 6개월간 보관 후 일괄 파기합니다.
              </p>
              <p>
                * 소명자료 제출과 관련 사항은 해당자에게 별도 통보예정으로 청약신청자가 청약 신청 시 잘못된 정보 기재(연락처, 주소 등)로 해당 정보를 받지 못하는 경우에는 당사는 책임지지 않으며 이에 대하여 이의를 제기할 수 없습니다.
              </p>
              <p>
                * 부적격 통보를 받거나 부적격 의심 사유가 있어 소명이 필요한 경우 사업주체가 요구하는 소명에 필요한 서류를 소명기간 내(계약 체결 이전)에 반드시 추가로 제출하여야 합니다.
              </p>
              <p>
                * 모든 증명서류는 최초 입주자모집공고일 이후 발행분에 한합니다.
              </p>
            </div>
          </div>
        </Element>
        ) : null}

        {/* 계약 안내 */}
        {sidebarList[6].isActive ? (
        <Element name={sidebarList[6].name}>
          <div className="section-contract" ref={contractRef} id="contract">
          <h3>계약 안내</h3>
            <h4>계약 일정</h4>
            <div className="table-container">
              <table className="table-col">
                <colgroup>
                  <col style={{ width: '34%' }} />
                  <col style={{ width: '35%' }} />
                  <col style={{ width: '33%' }} />
                </colgroup>
                <tbody>
                  <tr>
                    <td className="text-left border-bt">
                      <div className="text-top">계약 기간</div>
                      <div className="text-bold-large">2022.10.31(월) ~ 2022.11.2(수)</div>
                      <div className="text-bold-normal">3일간, (10:00 ~ 17:00)</div>
                    </td>
                    <td className="text-left border-bt">
                      <div className="text-top">계약 장소</div>
                      <div className="text-bold-large"> e편한세상 구미상모 트리베뉴 주택전시관 </div>
                      {/* <div className="text-bold-normal">{complexInfo?.addrBizExhibLnd || ''}</div> */}
                      <div className="text-bold-normal">(경상북도 구미시 신평동 301-5번지)</div>
                    </td>
                    <td className="text-left border-bt">
                      <div className="text-top">계약금 납부</div>
                      <div className="text-bold-large">지정계좌 무통장 입금</div>
                      <div className="text-bold-normal">[주택 전시관에서 계약금(현금 또는 수표) 수납 불가]</div>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>

            <h4 className="mt-50">계약 시 구비 서류</h4>
            <div className="table-container type01 type-document">
              <table className="table-col">
                <colgroup>
                  <col style={{ width: '10%' }} />
                  <col style={{ width: '5%' }} />
                  <col style={{ width: '5%' }} />
                  <col style={{ width: '15%' }} />
                  <col style={{ width: '11%' }} />
                  <col style={{ width: '50%' }} />
                </colgroup>
                <thead>
                  <tr>
                    <th className="line-b" rowSpan={2}>구 분</th>
                    <th className="line-b" colSpan={2}>서류유형</th>
                    <th className="line-b" rowSpan={2}>해당서류</th>
                    <th className="line-b" rowSpan={2}>발급기준</th>
                    <th className="line-b" rowSpan={2}>서류 제출대상 및 유의사항</th>
                  </tr>
                  <tr>
                    <th className="line-b">필수</th>
                    <th className="line-b border">
                      추가 <br />
                      <span> (해당자)</span>
                    </th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <th className="border" rowSpan={13}>
                      공통서류
                    </th>
                    <td className="border">
                      <img src={GetStyledCompImg('common/table-o.png')} alt="check"></img>
                    </td>
                    <td className="border"></td>
                    <td className="border">개인정보활용동의서</td>
                    <td className="border" rowSpan={6}>본인</td>
                    <td>
                      <ul>
                        <li>주택전시관 내 비치</li>
                      </ul>
                    </td>
                  </tr>
                  <tr>
                    <td className="border">
                      <img src={GetStyledCompImg('common/table-o.png')} alt="check"></img>
                    </td>
                    <td className="border"></td>
                    <td className="border">신분증</td>
                    <td>
                      <ul>
                        <li>주민등록증, 운전면허증, 여권(2020.12.21 이후 발급시 여권증명서 필요)</li>
                      </ul>
                    </td>
                  </tr>
                  <tr>
                    <td className="border">
                      <img src={GetStyledCompImg('common/table-o.png')} alt="check"></img>
                    </td>
                    <td className="border"></td>
                    <td className="border">주민등록표등본</td>
                    <td>
                      <ul>
                        <li>본인 및 세대원 전원의 성명, 주민등록번호(뒷자리포함), 주소변동사항, 세대구성사유 및 일자, 세대주 및 세대주와의 관계 등 “전체포함”하여 발급</li>
                      </ul>
                    </td>
                  </tr>
                  <tr>
                    <td className="border">
                      <img src={GetStyledCompImg('common/table-o.png')} alt="check"></img>
                    </td>
                    <td className="border"></td>
                    <td className="border">주민등록표초본</td>
                    <td>
                      <ul>
                        <li>주민등록번호(뒷자리포함), 주소변동사항 및 발생일(인정받고자하는 기간포함), 세대주 및 세대주와의 관계 “전체포함”하여 발급</li>
                      </ul>
                    </td>
                  </tr>
                  <tr>
                    <td className="border">
                      <img src={GetStyledCompImg('common/table-o.png')} alt="check"></img>
                    </td>
                    <td className="border"></td>
                    <td className="border">인감증명서, 인감도장</td>
                    <td>
                      <ul>
                        <li>본인 발급 인감증명서에 한함. (본인서명사실확인서 제출도 가능하나 본인 서명사실확인서 제출 시 제3자 대리신청은 불가)</li>
                      </ul>
                    </td>
                  </tr>
                  <tr>
                    <td className="border">
                      <img src={GetStyledCompImg('common/table-o.png')} alt="check"></img>
                    </td>
                    <td className="border"></td>
                    <td className="border">가족관계증명서<br />(상세)</td>
                    <td>
                      <ul>
                        <li>본인 및 세대원 전원의 성명, 주민등록번호(뒷자리포함) 전부 공개 “상세”로 발급</li>
                      </ul>
                    </td>
                  </tr>

                  <tr>
                    <td className="border">
                      <img src={GetStyledCompImg('common/table-o.png')} alt="check"></img>
                    </td>
                    <td className="border"></td>
                    <td className="border" rowSpan={4}>출입국사실증명서<br />(단신부임)</td>
                    <td className="border">본인</td>
                    <td>
                      <ul>
                        <li>
                        주민등록번호(뒷자리포함) 전부 공개 “상세”로 발급, 기록대조일을 본인 생년월일~입주자모집공고일로 출입국기록출력 여부를 Y로 설정하여 발급
                        </li>
                      </ul>
                    </td>
                  </tr>
                  <tr>
                    <td className="border"></td>
                    <td className="border">
                      <img src={GetStyledCompImg('common/table-o.png')} alt="check"></img>
                    </td>
                    <td className="border">배우자 및<br />세대원</td>
                    <td>
                      <ul>
                        <li>
                        주택공급신청자만 생업에 종사하기 위하여 국외에 체류하고 있는 경우<br />
                        - 주민등록번호 전체 표시, 기록대조일을 본인 생년월일~입주자모집공고일로 출입국기록출력 여부를 Y로 설정하여 발급
                        </li>
                      </ul>
                    </td>
                  </tr>
                  <tr>
                    <td className="border"></td>
                    <td className="border">
                      <img src={GetStyledCompImg('common/table-o.png')} alt="check"></img>
                    </td>
                    <td className="border">피부양<br />직계존속</td>
                    <td>
                      <ul>
                        <li>
                        직계존속을 부양가족으로 산정한 경우 아래의 경우 부양가족에 제외<br />
                        - 직계존속이 입주자모집공고일 기준 최근 3년 이내 계속하여 90일을 초과하여 해외에 체류한 경우에는 부양가족에서 제외<br />
                        - 주민등록번호 전체 표시, 기록대조일은 본인 생년월일부터 모집공고일 현재까지로 설정
                        </li>
                      </ul>
                    </td>
                  </tr>
                  <tr>
                    <td className="border"></td>
                    <td className="border">
                      <img src={GetStyledCompImg('common/table-o.png')} alt="check"></img>
                    </td>
                    <td className="border">피부양<br />직계비속</td>
                    <td>
                      <ul>
                        <li>
                        직계비속을 부양가족으로 산정한 경우 아래의 경우 부양가족에 제외<br />
                        - 만 30세 미만 미혼 자녀 : 입주자모집공고일 현재 기준 계속하여 90일을 초과하여 해외에 체류 중인 경우<br />
                        - 만 30세 이상 미혼 자녀 : 입주자모집공고일 기준 최근 1년 이내 계속하여 90일을 초과하여 해외에 체류한 경우<br />
                        - 주민등록번호 전체 표시, 기록대조일은 본인 생년월일부터 모집공고일 현재까지로 설정
                        </li>
                      </ul>
                    </td>
                  </tr>

                  <tr>
                    <td className="border">
                      <img src={GetStyledCompImg('common/table-o.png')} alt="check"></img>
                    </td>
                    <td className="border"></td>
                    <td className="border">배우자 주민등록표등본</td>
                    <td className="border">배우자</td>
                    <td>
                      <ul>
                        <li>
                        주민등록표등본상 배우자가 분리된 경우 제출(상기 등본 발급시 유의사항에 따라 발급)<br/>
                        - 본인 및 세대원 전원의 성명, 주민등록번호(뒷자리포함), 주소변동사항, 세대구성사유 및 일자, 세대주 및 세대주와의 관계 등 “전체 포함”하여 발급
                        </li>
                      </ul>
                    </td>
                  </tr>
                  <tr>
                    <td className="border"></td>
                    <td className="border">
                      <img src={GetStyledCompImg('common/table-o.png')} alt="check"></img>
                    </td>
                    <td className="border">복무확인서</td>
                    <td className="border">본인</td>
                    <td>
                      <ul>
                        <li>
                          10년 이상 장기 복무 군인 자격으로 신청하는 경우(10년 이상 군 복무 기간 명시)
                        </li>
                      </ul>
                    </td>
                  </tr>
                  <tr>
                    <td className="border">
                      <img src={GetStyledCompImg('common/table-o.png')} alt="check"></img>
                    </td>
                    <td className="border"></td>
                    <td className="border">혼인관계증명서(상세)</td>
                    <td className="border">본인</td>
                    <td>
                      <ul>
                        <li>
                        성명, 주민등록번호(세대원 포함) 포함하여 ‘상세’로 발급
                        </li>
                      </ul>
                    </td>
                  </tr>

                  <tr>
                    <th className="border" rowSpan={2}>부적격 통보를<br />받은자</th>
                    <td className="border"></td>
                    <td className="border">
                      <img src={GetStyledCompImg('common/table-o.png')} alt="check"></img>
                    </td>
                    <td className="border">해당 주택에 대한<br />소명 자료</td>
                    <td className="border">해당주택</td>
                    <td>
                      <ul>
                        <li>건물 등기사항전부증명서, 건축물대장등본, 무허가건물확인서, 건축물철거멸실신고서 등<br />
                        - “소형・저가주택등”임을 증명하는 서류(주택공시가격 증명원 등)<br />
                        - 기타 무주택자임을 증명하는 서류
                        </li>
                      </ul>
                    </td>
                  </tr>
                  <tr>
                    <td className="border"></td>
                    <td className="border">
                      <img src={GetStyledCompImg('common/table-o.png')} alt="check"></img>
                    </td>
                    <td className="border">사업주체가 요구하여<br />인정하는 서류</td>
                    <td className="border">해당주택</td>
                    <td>
                      <ul>
                        <li>해당 기관의 당첨사실 무효확인서 등 사업주체가 요구하여 인정하는 서류</li>
                      </ul>
                    </td>
                  </tr>

                  <tr>
                    <th className="border border-bt" rowSpan={3}>제3자 대리인<br />신청 시 추가서류</th>
                    <td className="border">
                      <img src={GetStyledCompImg('common/table-o.png')} alt="check"></img>
                    </td>
                    <td className="border"></td>
                    <td className="border">인감증명서, 인감도장</td>
                    <td className="border">본인</td>
                    <td>
                      <ul>
                        <li>본인 발급 인감증명서에 한함 [용도 : 위임용(본인 발급용)]<br />
                        ※ 본인서명사실확인서 제출 시 제3자 대리신청은 불가</li>
                      </ul>
                    </td>
                  </tr>
                  <tr>
                    <td className="border">
                      <img src={GetStyledCompImg('common/table-o.png')} alt="check"></img>
                    </td>
                    <td className="border"></td>
                    <td className="border">위임장</td>
                    <td className="border">본인</td>
                    <td>
                      <ul>
                        <li>청약자의 인감도장 날인, 접수장소에 비치</li>
                      </ul>
                    </td>
                  </tr>
                  <tr>
                    <td className="border border-bt">
                      <img src={GetStyledCompImg('common/table-o.png')} alt="check"></img>
                    </td>
                    <td className="border border-bt"></td>
                    <td className="border border-bt">대리인 신분증, 도장</td>
                    <td className="border border-bt">대리인</td>
                    <td className='border-bt'>
                      <ul>
                        <li>위임인과 수임인 모두의 신분증 확인 필요</li>
                      </ul>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
            <div className="caution-text">
              <p>
                * 모든 제출서류는 입주자모집공고일[2022.09..29(목)] 이후 발행분에 한하며, 직인 날인이 없거나 직인 날인 된 서류를 팩스로 전송받은 경우 인정하지 않습니다.
              </p>
              <p>
                * 본인 이외에는 모두 대리 제출자로 간주하며(직계존·비속 포함), 대리 제출자는 위임장, 당첨자의 인감도장 및 인감증명서(본인 발급용), 본인 및 대리인의 신분증을 추가로 구비하여야 합니다.
              </p>
              <p>
                * 주민등록표등·초본 발급 시 과거 주소 변동 사항 및 변동 사유, 세대 구성일 및 사유, 발생일 등이 포함되어야 합니다.
              </p>
              <p>
                * 제출한 서류에 대해 위변조 검증을 실시하며, 제출 서류의 위·변조 확인 시 수사 기관에 고발 조치될 수 있습니다.
              </p>
            </div>
            

            {/* 분양대금 납부 일정 */}
            <h4 className="mt-50">분양대금 납부 일정</h4>
            <div className="table-container">
              <table className="table-col">
                <colgroup>
                  <col style={{ width: '10%' }} />
                  <col style={{ width: '10%' }} />
                  <col style={{ width: '10%' }} />
                  <col style={{ width: '10%' }} />
                  <col style={{ width: '10%' }} />
                  <col style={{ width: '10%' }} />
                  <col style={{ width: '10%' }} />
                  <col style={{ width: '10%' }} />
                  <col style={{ width: '20%' }} />
                </colgroup>
                <thead>
                  <tr>
                    <th className="line-b" rowSpan={2} colSpan={2}>
                      계약금(10%)
                    </th>
                    <th className="line-b" colSpan={6}>
                      중도금(60%)
                    </th>
                    <th className="line-b " rowSpan={2}>
                      잔금(30%)
                    </th>
                  </tr>
                  <tr>
                    <th className="line-b border ">1회 (10%) </th>
                    <th className="line-b border ">2회 (10%) </th>
                    <th className="line-b border ">3회 (10%) </th>
                    <th className="line-b border ">4회 (10%) </th>
                    <th className="line-b border ">5회 (10%) </th>
                    <th className="line-b border ">6회 (10%) </th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td className="border border-bt">계약시<br/>(1천만원)</td>
                    <td className="border border-bt">계약후<br />1개월 이내<br/>(10%-1천만원)</td>
                    <td className="border border-bt">2023.03.20</td>
                    <td className="border border-bt">2023.06.20</td>
                    <td className="border border-bt">2023.10.20</td>
                    <td className="border border-bt">2024.02.20</td>
                    <td className="border border-bt">2024.06.20</td>
                    <td className="border border-bt">2024.10.21</td>
                    <td className='border-bt'>입주지정일</td>
                  </tr>
                </tbody>
              </table>
            </div>

            <h4 className="mt-50">분양 대금 및 추가 선택 품목 납부 계좌</h4>
            <div className="table-container">
              <table className="table-col">
                <colgroup>
                  <col style={{ width: '25%' }} />
                  <col style={{ width: '25%' }} />
                  <col style={{ width: '25%' }} />
                  <col style={{ width: '25%' }} />
                </colgroup>
                <thead>
                  <tr>
                    <th className="line-b">구분</th>
                    <th className="line-b">금융기관</th>
                    <th className="line-b">계좌번호</th>
                    <th className="line-b">예금주</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td className="border">분양대금</td>
                    <td className="border">농협</td>
                    <td className="border">351-1239-5883-43</td>
                    <td>대신자산신탁 주식회사</td>
                  </tr>
                  <tr>
                    <td className="border border-bt">추가선택품목</td>
                    <td className="border border-bt">우리은행</td>
                    <td className="border border-bt">1005-504-384490</td>
                    <td className='border-bt'>디엘건설 주식회사</td>
                  </tr>
                </tbody>
              </table>
            </div>
            <div className="caution-text">
              <p>
                * 분양금액은 약정된 계약금, 중도금, 잔금 납부일에 지정된 계좌로 무통장 입금(입금시 동ㆍ호수 또는 계약자 성명 필히 기재)하시기 바라며, 별도의 통지를 하지 않습니다.
              </p>
              <p>
                * 상기 계좌로 납부하지 아니한 분양금액은 인정치 않으며 또한 주택도시보증공사의 분양보증을 받을 수 없습니다.
              </p>
            </div>
          </div>
        </Element>
        ) : null}

        {/* FAQ */}
        {sidebarList[7].isActive ? (
        <Element name={sidebarList[7].name}>
          <div className="FAQs-container" ref={faqsRef} id="faqs">
            <h3>자주 묻는 질문</h3>
            <div className="accordion-container">
              <div className="accordion" id="accordionExample">
                {faqList && faqList.map(item => (
                  <Accordion
                    key={item.noSral}
                    faq={item}
                    active={item.noSral === activePostNumber}
                    setActiveNumber={setActivePostNumber}
                  />
                ))}

                {faqList && faqList.length === 0 && (
                  <div className="none-data">
                    <i className="ico-no-result"></i>
                    <p className="txt-desc-small01 font-color04 mt-15">FAQ가 존재하지 않습니다.</p>
                  </div>
                )}
              </div>
            </div>
            <div className="subtit">
              {
                `※ 상세한 분양 상담은 ‘${mainModel?.mainData?.data?.nmBizLnd}’ 대표 번호 ${mainModel?.mainData?.data?.cntsBiz}로 문의 부탁드립니다.`
              }
            </div>
          </div>
        </Element>
        ) : null}
      </div>
    </div>
  );
});

export default Info;
